import Swal from 'sweetalert2';
import ReactDOMServer from 'react-dom/server';

interface SweetAlertComponentProps {
    logo: any; // URL or path to the logo
    text: string; // Text to display in the alert
    buttonText: string | ""; // Text for the button
    onButtonClick: () => void; // Callback function when button is clicked
    header?: string| null;
}

const SweetAlertComponent = {
    showAlert: ({ logo, text, buttonText, onButtonClick, header=null }: SweetAlertComponentProps) => {
        const logoString = ReactDOMServer.renderToString(logo);    
        Swal.fire({
            html: `
        <div style="text-align: center;" className="sweetaalert-modal">
        ${header ? `<div className="sweetalert-header" style="margin-bottom: 20px; text-align:start;">${header}</div>` : ''}
          <div className="d-flex justify-content-center" style="margin-top: 50px; margin-bottom:20px;">
            ${logoString}
          </div>
          <p>${text}</p>
        </div>
      `,
            showCloseButton: true,
            confirmButtonText: buttonText,
            confirmButtonColor: '#ccdc54',
            willClose: () => {
                onButtonClick();
            },
            customClass: {
                confirmButton: 'swal-confirm-button'
              },
        });
    },
};

export default SweetAlertComponent; 